import instance from "../../URL/index";
const axios = instance.axios;

export default {
    services: {
        /** Accept Quote
         * @param {string} id - The ID of the quote
         * @returns {Promise} - The Axios promise
         */
        acceptQuote: (quoteId, token = "") => {
            return axios(token).patch(`/quotes/${quoteId}/accept`);
        },
        /** Reject Quote
         * @param {string} id - The ID of the quote
         * @returns {Promise} - The Axios promise
         */
        rejectQuote: (quoteId, payload, token = "") => {
            return axios(token).patch(`/quotes/${quoteId}/reject`, payload);
        },
        /** Get Quote Details
         * @param {string} id - The ID of the quote
         * @returns {Promise} - The Axios promise
         */
        getQuoteDetails: (quoteId, token = "") => {
            return axios(token).get(`/quotes/${quoteId}?populate=true`);
        }
    }
};